import { Breadcrumb, BreadcrumbItem } from 'reactstrap';

import './styles/styles.scss';
import { IFilters } from '../../hooks/useFilters';

import { convertDateToBrazilFormat } from '@repo/ui';

interface IProps {
  filters: IFilters;
  lastDayOfMonth: string;
  firstDayOfMonth: string;
}

export const NavFilters = ({
  filters,
  lastDayOfMonth,
  firstDayOfMonth,
}: IProps) => {
  return (
    <Breadcrumb listClassName="bg-light mb-0">
      <BreadcrumbItem>
        <i className="ri-home-5-line" />{' '}
      </BreadcrumbItem>
      <BreadcrumbItem>{`${filters?.entity?.label || 'Todas as organizações'}`}</BreadcrumbItem>
      <BreadcrumbItem>{`${filters?.course?.label || 'Todos os cursos'}`}</BreadcrumbItem>
      <BreadcrumbItem>{`${filters?.semester?.label || 'Todos os Semestres'}`}</BreadcrumbItem>
      <BreadcrumbItem>{`${filters?.curricularUnit?.label || 'Todas as Unidades Curriculares'}`}</BreadcrumbItem>
      <BreadcrumbItem>{`${filters?.group?.label || 'Todos os grupos'}`}</BreadcrumbItem>
      <BreadcrumbItem active>
        {(filters?.period?.length > 0 &&
          `${convertDateToBrazilFormat(filters?.starts)} até ${convertDateToBrazilFormat(filters?.ends)}`) ||
          `${convertDateToBrazilFormat(firstDayOfMonth)} até ${convertDateToBrazilFormat(lastDayOfMonth)}`}
      </BreadcrumbItem>
    </Breadcrumb>
  );
};
